import useClientMetrics from "../../hooks/useClientMetrics.js";
import { useEffect } from "react";
import { getBrandedFarePriceMismatchMetricName } from "../components/FareSelector/utils.js";
import useEvents from "../../hooks/useEvents.js";
import { carrierUtils } from "@flights/web-api-utils-universal";
export default function useTrackFirstFarePriceMismatch(flight, brandedFareOffers) {
    const { trackClientMetric } = useClientMetrics();
    const { grumble } = useEvents();
    useEffect(() => {
        if (brandedFareOffers && brandedFareOffers.length > 0) {
            const firstFare = brandedFareOffers[0];
            const carriers = carrierUtils.getUniqueMarketingCarriers(flight.segments);
            const pointOfSale = flight.pointOfSale;
            trackClientMetric(getBrandedFarePriceMismatchMetricName(flight.priceBreakdown.total, firstFare.priceBreakdown.total, carriers, pointOfSale, grumble));
        }
    }, [brandedFareOffers, flight, trackClientMetric, grumble]);
}
